/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shipment_Booking_Not_ReadyInputs */

const en_error_shipment_booking_not_ready = /** @type {(inputs: Error_Shipment_Booking_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The booking cannot be sent: the order has no ship-to address, or the warehouse has no code on TLG Shipping.`)
};

/**
* | output |
* | --- |
* | "The booking cannot be sent: the order has no ship-to address, or the warehouse has no code on TLG Shipping." |
*
* @param {Error_Shipment_Booking_Not_ReadyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_shipment_booking_not_ready = /** @type {((inputs?: Error_Shipment_Booking_Not_ReadyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shipment_Booking_Not_ReadyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_shipment_booking_not_ready(inputs)
});